// GENERATED FILE, DO NOT MANUALLY EDIT
import { html } from '@horizon/base';
import { HznIconBase } from '../../icon/icon-base.js';
import './types.js';
/**
 *
 * @tag hzn-icon-hide
 * @tagname hzn-icon-hide
 * @summary An individual icon for Horizon
 */
export class HznIconHide extends HznIconBase {
    render() {
        return html `<div class="hzn-icon" aria-hidden="true"><svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path fill-rule="evenodd" clip-rule="evenodd" d="M6.9727 21.9895L8.54387 22.7221L9.46064 20.7561C10.2819 20.916 11.1332 21 12 21C17.8554 21 23 17.1673 23 12C23 8.4782 20.6102 5.57632 17.2344 4.0853L17.8126 2.84524L16 2L15.6176 2.82004L15.6237 2.82278L6.9727 21.9895ZM13.32 3.06524C12.8854 3.02211 12.4447 3 12 3C6.14463 3 1 6.83274 1 12C1 15.2145 2.99093 17.9125 5.90535 19.4927L6.727 17.6723C4.42818 16.3663 3 14.2466 3 12C3 8.33071 6.80967 5 12 5C12.1488 5 12.2965 5.00274 12.443 5.00815L13.32 3.06524ZM11.0404 8.11586C9.29469 8.54571 8 10.1217 8 12C8 12.6673 8.16341 13.2965 8.45239 13.8496L11.0404 8.11586ZM12 19C11.4269 19 10.8706 18.9594 10.3345 18.8822L11.6842 15.9877C11.7884 15.9959 11.8937 16 12 16C14.2091 16 16 14.2091 16 12C16 10.9073 15.5619 9.91694 14.8517 9.19501L16.394 5.88742C19.2022 7.11852 21 9.47937 21 12C21 15.6693 17.1903 19 12 19Z" fill="currentColor"></path>
</svg></div>`;
    }
}
//# sourceMappingURL=hide.js.map